/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Wrapped_Summary_Next_TodayInputs */

const en_us2_wrapped_summary_next_today = /** @type {(inputs: Wrapped_Summary_Next_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The next one has already started: ${i?.session} is today.`)
};

const pt_br2_wrapped_summary_next_today = /** @type {(inputs: Wrapped_Summary_Next_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A próxima já começou: o ${i?.session} é hoje.`)
};

const es_419_wrapped_summary_next_today = /** @type {(inputs: Wrapped_Summary_Next_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La próxima ya empezó: hoy toca ${i?.session}.`)
};

const pt_pt2_wrapped_summary_next_today = /** @type {(inputs: Wrapped_Summary_Next_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A próxima já começou: o ${i?.session} é hoje.`)
};

const fr_fr2_wrapped_summary_next_today = /** @type {(inputs: Wrapped_Summary_Next_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La suivante a déjà commencé : ${i?.session}, c'est aujourd'hui.`)
};

const de_de2_wrapped_summary_next_today = /** @type {(inputs: Wrapped_Summary_Next_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die nächste hat schon begonnen: ${i?.session} ist heute.`)
};

const it_it2_wrapped_summary_next_today = /** @type {(inputs: Wrapped_Summary_Next_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La prossima è già iniziata: ${i?.session} è oggi.`)
};

/**
* | output |
* | --- |
* | "The next one has already started: {session} is today." |
*
* @param {Wrapped_Summary_Next_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_summary_next_today = /** @type {((inputs: Wrapped_Summary_Next_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Summary_Next_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_summary_next_today(inputs)
	if (locale === "es-419") return es_419_wrapped_summary_next_today(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_summary_next_today(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_summary_next_today(inputs)
	if (locale === "de-DE") return de_de2_wrapped_summary_next_today(inputs)
	if (locale === "it-IT") return it_it2_wrapped_summary_next_today(inputs)
	return en_us2_wrapped_summary_next_today(inputs)
});
export { wrapped_summary_next_today as "wrapped.summary_next_today" }